import {
	GETWALLETOWNERIDNAMELISTAPI_SUCCESS,
	GETWALLETOWNERIDNAMELISTAPI_FAILED,
	RESET_GETWALLETOWNERIDNAMELISTAPI,
	LOADING_GETWALLETOWNERIDNAMELISTAPI,
	NETWORK_ERROR_GETWALLETOWNERIDNAMELISTAPI
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetWalletOwnerIdAndNameListApi = () => {
	return { type: RESET_GETWALLETOWNERIDNAMELISTAPI };
};

const getWalletOwnerIdAndNameListApi =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_GETWALLETOWNERIDNAMELISTAPI });
		await adminServices
			.post("getWalletOwnerIdAndNameListCopy", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(getWalletOwnerIdAndNameListApisuccess(res.data));
						break;
					default:
						dispatch(getWalletOwnerIdAndNameListApiFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_GETWALLETOWNERIDNAMELISTAPI,
					payload: err
				});
			});
	};
function getWalletOwnerIdAndNameListApisuccess(data) {
	return {
		type: GETWALLETOWNERIDNAMELISTAPI_SUCCESS,
		payload: data
	};
}
function getWalletOwnerIdAndNameListApiFailed(data) {
	return {
		type: GETWALLETOWNERIDNAMELISTAPI_FAILED,
		payload: data
	};
}

export { resetGetWalletOwnerIdAndNameListApi, getWalletOwnerIdAndNameListApi };
